import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React from 'react';
import ResizeObserver from 'resize-observer-polyfill';

var ParentSize =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ParentSize, _React$Component);

  function ParentSize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      width: 0,
      height: 0,
      top: 0,
      left: 0
    };
    _this.resize = debounce(_this.resize.bind(_assertThisInitialized(_this)), props.debounceTime);
    _this.setTarget = _this.setTarget.bind(_assertThisInitialized(_this));
    _this.animationFrameID = null;
    return _this;
  }

  var _proto = ParentSize.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.ro = new ResizeObserver(function (entries
    /** , observer */
    ) {
      if (entries === void 0) {
        entries = [];
      }

      entries.forEach(function (entry) {
        var _entry$contentRect = entry.contentRect,
            left = _entry$contentRect.left,
            top = _entry$contentRect.top,
            width = _entry$contentRect.width,
            height = _entry$contentRect.height;
        _this2.animationFrameID = window.requestAnimationFrame(function () {
          _this2.resize({
            width: width,
            height: height,
            top: top,
            left: left
          });
        });
      });
    });
    this.ro.observe(this.target);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.cancelAnimationFrame(this.animationFrameID);
    this.ro.disconnect();
  };

  _proto.resize = function resize(_ref) {
    var width = _ref.width,
        height = _ref.height,
        top = _ref.top,
        left = _ref.left;
    this.setState(function () {
      return {
        width: width,
        height: height,
        top: top,
        left: left
      };
    });
  };

  _proto.setTarget = function setTarget(ref) {
    this.target = ref;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        debounceTime = _this$props.debounceTime,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["className", "children", "debounceTime"]);

    return React.createElement("div", _extends({
      style: {
        width: '100%',
        height: '100%'
      },
      ref: this.setTarget,
      className: className
    }, restProps), children(_extends({}, this.state, {
      ref: this.target,
      resize: this.resize
    })));
  };

  return ParentSize;
}(React.Component);

export { ParentSize as default };
ParentSize.defaultProps = {
  debounceTime: 300
};
ParentSize.propTypes = {
  className: PropTypes.string,
  children: PropTypes.func.isRequired,
  debounceTime: PropTypes.number
};